import React, { useCallback, useRef, useState } from "react";
import "ag-grid-community/styles/ag-grid.css"; // Core CSS
import "ag-grid-community/styles/ag-theme-quartz.css"; // Theme
import PlusButtonIcon from "../../../../../../assets/images/PlusButtonIcon.svg";
import ModalDelete from "../../../../../../components/ModalDelete";
import Loading from "../../../../../../core/common/Loading";
import Grid from "../../../../../../components/Grid";
import { GridHandle } from "../../../../../../components/Grid/model/Grid";
import {
  formatDateTimeBR
} from "../../../../../../helpers/format";
import CustomModal from "../../../../../../components/CustomModal";

import { FrontendNotification } from "../../../../../../shared/Notification";
import { toast } from "sonner"
import Create from "./Create";

interface Props {
  isView?: boolean;
  isEdit?: boolean;
  onClear: () => void;
  onConfirm: () => void;
  selectedRow?: any; // Defines data later
  id_operacao_porto_carrossel_transportadora?: number;
}

const CarrosselVeiculos: React.FC<Props> = (props: Props) => {
  const [selectedRow, setSelectedRow] = useState<any>();
  const [isRemove, setIsRemove] = useState(false);
  const [loading, setLoading] = useState(false);
  const [showCreate, setShowCreate] = useState(false);

  const defaultColumns = [
    {
      field: "placa_dianteira",
      fieldName: "placa_dianteira",
      headerName: "Placa Dianteira",
      filter: true,
      valueFormatter: (params: any) => {
        if (params.value) {
          return params.value;
        }
        return "---";
      },
    },
    {
      field: "usuario",
      headerName: "Usuário",
      filter: true,
      valueFormatter: (params: any) => {
        if (params.value) {
          return params.value;
        }
        return "---";
      },
    },
    {
      field: "data_historico",
      headerName: "Data do Histórico",
      flex: 1,
      valueFormatter: (params: any) => {
        if (params.value) {
          return formatDateTimeBR(params.value);
        }

        return "---";
      },
    },
  ];

  const gridRef = useRef<GridHandle>(null);

  const defaultFilters = {
    id_operacao_porto_carrossel_transportadora: props.id_operacao_porto_carrossel_transportadora,
  }

  const onDelete = useCallback(async (_rowId?: number) => {
    try {
      setLoading(true);

      // Logic to be defined later
      toast.success("Veiculo removido com sucesso!")

      // await api.post("/deletar/transportadorasVeiculos", body);

      FrontendNotification("Veiculo removido com sucesso!", "success")

      setLoading(false);

      gridRef.current?.api?.refreshCells({
        force: true,
      })

    } catch {
      setLoading(false);
    }
  }, []);

  return (
    <CustomModal
      title="Veículos do Carrossel"
      isScreenLg
      onClose={props.onClear}
    >
      <div className="w-full p-2 mb-5">
        <Loading loading={loading} skeletonVariant="grid" skeletonRows={6} skeletonColumns={3} skeletonFooterButtons={0} />

        {showCreate && (
          <Create
            selectedRow={selectedRow}
            onClear={() => {
              setShowCreate(false);
              setSelectedRow(undefined);
            }}
            onConfirm={() => {
              setShowCreate(false)
              gridRef.current?.api?.refreshCells({
                force: true,
              })
            }}
            id_operacao_porto_carrossel_transportadora={props.id_operacao_porto_carrossel_transportadora}
          />
        )}
        
        {isRemove && (
          <ModalDelete
            isOpen={isRemove}
            title="Deseja desativar o veiculo?"
            message="Por favor, confirme que você deseja desativar o veiculo:"
            onCancel={() => setIsRemove(!isRemove)}
            onConfirm={() => {
              setIsRemove(!isRemove)
              onDelete(selectedRow?.id)
            }}
            row={String(selectedRow?.placa_dianteira_veiculo || "")}
          />
        )}
        
        {/* Info Component would go here */}

        <div className="w-full flex justify-end mr-6">
          <button
            className="flex items-center justify-center h-10 w-36 bg-[#062D4E] text-[#FFFFFF] text-sm font-light border-none rounded-full mr-8"
            onClick={() => setShowCreate(!showCreate)}
          >
            Adicionar <img src={PlusButtonIcon} alt="" className="ml-2" />
          </button>
        </div>
        <div className="w-full mt-4 flex justify-center">
          <Grid
            ref={gridRef}
            isModal
            columns={defaultColumns}
            filters={[]}
            customFilters={defaultFilters}
            pagination
            path="/listar/operacaoPortoCarrosselTransportadoraVeiculos"
            onDelete={(data: any) => {
              setIsRemove(!isRemove);
              setSelectedRow(data);
            }}
            status={[]}
          />
        </div>
      </div>
    </CustomModal>
  );

};
export default CarrosselVeiculos;
